<template>
    <div class="loaderCont loaderOrdersList" v-show="this.isLoading">
        <div class="loader"></div>
    </div>
    <div class="HistoryTable Table" v-show="!this.isLoading">
        <TableFilter 
            :ShowFilters = !this.isInHome
            :FilterMap="this.FilterMap" 
            @filtra="this.Search($event)" 
            @moreFilter="this.DeepSearch($event)"
        />
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
                <tr class="TableHead">
                    <th scope="col" class="HTOrderCode">{{ this.risorse["NumeroOrdine"] }}</th>
                    <th scope="col" class="HTOrderDate">{{ this.risorse["DataOrdine"] }}</th>
                    <th scope="col" class="HTShippingAddress">{{ this.risorse["IndirizzoDestinazione"] }}</th>
                    <th scope="col" class="HTBillingData">{{ this.risorse["IndirizzoFatturazione"] }}</th>
                    <th scope="col" class="HTTotal">{{ this.risorse["TotaleOrdine"] }}</th>
                    <th scope="col" class="HTAddToBasket">{{ this.risorse["ProdottiNonDisponibili"] }}</th>
                </tr>
                <HistoryTableRow v-for="ordine in this.ListaOrdini" :key="ordine.NumeroOrdine" :ordine="ordine"/>
            </tbody>
        </table>
    </div>
</template>
<script>

import OrderHistoryService from "@/services/orderHistory.service.js";
import {priceMixin, risorseMixin} from "@/mixin.js";
import HistoryTableRow from "@/components/HistoryTableRow.vue";
import TableFilter from "@/components/TableFilter.vue";

export default {
    name: "Historytable",
    computed:{
        IsReduced: function(){
            return this.count != null && this.count != undefined && this.count > 0;
        },
        ListaOrdini: function(){
            if(this.IsReduced && this.listaOrdini != null && this.listaOrdini != undefined && this.listaOrdini.length > 0){
                let sortedList = this.listaOrdini.sort((x,y) =>{ 
                    const dataX = new Date(
                        x.DataOrdine.split('/').reverse().join('/')
                    );
                    const dataY = new Date(
                        y.DataOrdine.split('/').reverse().join('/')
                    );
                    if (dataX > dataY) return -1;
                    if (dataX < dataY) return 1;
                    return 0;
                });
                return sortedList.slice(0,10);
            }else{
                return this.listaOrdini;
            }
        }
    },
    props:{
        count: Number,
        isInHome: Boolean
    },
    data(){
        return {
            listaOrdini: [],
            isLoading: true,
            isLoading: false,
            searchTimeout: 500,
            FilterMap:{
                Cap: false,
                Prov: false,
                DestTxt: true,
                DtDocum: true,
                TpDocum: false,
                NumRata: false,
                Import: true,
                TotOrdine: true
            }
        }
    },
    mixins: [priceMixin, risorseMixin],
    components: {
        HistoryTableRow,
        TableFilter
    },
    methods:{
        GetData: function(ev){
            this.isLoading = true;
            OrderHistoryService.GetTestataOrdiniByCliente(this.$store.getters.getToken,this.$store.getters.getAnagraficaAzienda.CodiceCliente,720,ev).then(
                (data) => {
                    if(!data){
                        this.$router.push("/");
                    }
                    else{
                        this.listaOrdini = data;
                    }
                    this.isLoading = false;
                }

            ).catch(
                (err) => {console.log(err)}
            );
        },
        DeepSearch: function(ev){
            this.GetData(ev);
        },
        Search:function(ev){
            if(this.searchTimeout != null){
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => this.GetData(ev), 500);
        },
    },
    mounted: function(){
        this.GetData();
    }
}
</script>

<style>
.loaderOrdersList{
    padding-top: 0 !important;
}
</style>